import React from 'react';
import { Users, UserPlus, Search } from 'lucide-react';
import V4CeoDeptTemplate from './V4CeoDeptTemplate';
import { PEOPLE_DEPT_DATA, PEOPLE_DEPT_CHAT_RESPONSES } from '../../data/peopleDeptData';
import { PEOPLE_DEEP_DIVE, PEOPLE_ALERT_DEEP_DIVES, PEOPLE_DECISION_DEEP_DIVES, PEOPLE_ROW_DEEP_DIVES } from '../../data/peopleDeepDiveData';

const RoleRow = ({ item, idx, isDark, onDeepDive }) => {
  const tp = isDark ? 'text-white' : 'text-slate-800';
  const ts = isDark ? 'text-white/50' : 'text-slate-500';
  const border = isDark ? 'border-white/[0.06]' : 'border-black/[0.06]';
  const statusColor = { interviewing: isDark ? 'text-blue-400' : 'text-blue-600', screening: isDark ? 'text-indigo-400' : 'text-indigo-600', 'pending approval': isDark ? 'text-amber-400' : 'text-amber-600' };
  const isCritical = item.urgency === 'critical';

  return (
    <div className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border ${isCritical ? (isDark ? 'border-red-500/15 bg-red-950/10' : 'border-red-200/50 bg-red-50/30') : `${border} ${isDark ? 'bg-[#0d1b2a]' : 'bg-[#f0ece4]'}`}`} data-testid={`role-${item.id}`}>
      <UserPlus className={`w-3.5 h-3.5 flex-shrink-0 ${isCritical ? (isDark ? 'text-red-400' : 'text-red-500') : (isDark ? 'text-indigo-400' : 'text-indigo-600')}`} />
      <div className="flex-1 min-w-0">
        <p className={`text-[11px] font-semibold truncate ${tp}`}>{item.title}</p>
        <p className={`text-[9px] mt-0.5 ${ts}`}>{item.department} · {item.daysOpen > 0 ? `${item.daysOpen}d open` : 'New'} · {item.candidates} candidates</p>
      </div>
      <button
        onClick={() => onDeepDive && onDeepDive(item)}
        className={`flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-medium transition-colors ${isDark ? 'bg-indigo-500/10 text-indigo-400 hover:bg-indigo-500/20' : 'bg-indigo-500/10 text-indigo-600 hover:bg-indigo-500/15'}`}
        data-testid={`role-deep-dive-${item.id}`}
      >
        <Search className="w-2.5 h-2.5" /> Deep Dive
      </button>
      <span className={`text-[9px] font-medium flex-shrink-0 ${statusColor[item.status] || ts}`}>{item.status}</span>
    </div>
  );
};

const V4PeopleDept = ({ isDark, onWorkflowToggle, workflowPanelOpen }) => (
  <V4CeoDeptTemplate
    isDark={isDark} onWorkflowToggle={onWorkflowToggle} workflowPanelOpen={workflowPanelOpen}
    data={PEOPLE_DEPT_DATA} chatResponses={PEOPLE_DEPT_CHAT_RESPONSES}
    deptIcon={Users} deptLabel="People" deptColor={isDark ? 'text-pink-400' : 'text-pink-600'}
    agentId="tali" agentName="Tali" escalateLabel="Escalate to Riya" escalateTarget="Riya Kapoor"
    col2Icon={UserPlus} col2Label="Open Roles" col2Items={PEOPLE_DEPT_DATA.openRoles}
    col2Renderer={(item, i, dark, onDeepDive) => <RoleRow key={item.id} item={item} idx={i} isDark={dark} onDeepDive={onDeepDive} />}
    testIdPrefix="people-dept"
    deepDiveScript={PEOPLE_DEEP_DIVE}
    alertDeepDives={PEOPLE_ALERT_DEEP_DIVES}
    decisionDeepDives={PEOPLE_DECISION_DEEP_DIVES}
    rowDeepDives={PEOPLE_ROW_DEEP_DIVES}
    rowKeySelector={(item) => item.id}
  />
);

export default V4PeopleDept;
